import { Suspense } from 'react';
import ReactDOM from 'react-dom/client'; // 
import { Provider } from 'jotai';
import App from './app/app';
import Compose from './app/contexts/Compose';
import { MainProvider } from './app/contexts/MainContext';
import { BrowserRouter } from 'react-router-dom';
import LayzyLoadCommon from './app/components/layzyload-common/LayzyLoadCommon';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './libs/configs/auth-config-microsoft';
import { MsalProvider } from '@azure/msal-react';
import './libs/configs/i18n';
import 'env.d.ts';

export const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <Provider>
      <Suspense fallback={<LayzyLoadCommon />}>
        <MsalProvider instance={msalInstance}>
          <Compose components={[MainProvider]}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </Compose>
        </MsalProvider>

      </Suspense>
    </Provider>
);
